import { useQuery } from "@tanstack/react-query";
import { useParams } from "next/navigation";

import { getCountry } from "@/actions/countries";
import { getLocationsByOrgId, getOrgCurrencyCode } from "@/actions/locations";
import { DATE_FORMATS } from "@/constants/date-formats";
import { queryKeys } from "@/constants/query";
import { isValidOrgId } from "@/lib/utils";

const getOrgSettings = async (orgId: string) => {
  const [currencyCode, locations] = await Promise.all([
    getOrgCurrencyCode(orgId),
    getLocationsByOrgId(orgId),
  ]);

  const country = locations[0]?.countryId
    ? await getCountry(locations[0]?.countryId)
    : null;

  return {
    currencyCode,
    location: locations[0],
    country,
    dateFormat: DATE_FORMATS[country?.countryCode as keyof typeof DATE_FORMATS],
  };
};

const useOrgSettings = () => {
  const params = useParams();
  const orgId = params.orgId as string;

  const { data: orgSettings } = useQuery({
    queryKey: queryKeys.getOrgSettings(orgId),
    queryFn: () => getOrgSettings(orgId),
    enabled: isValidOrgId(orgId),
  });

  return orgSettings;
};

export default useOrgSettings;
